import { ExpressionRule } from "../../ExpressionRule";
import { ExpressionValue } from "../../ExpressionValue";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class SubstractExpression extends ExpressionRule {
    readonly __type: string = "Substract";
    value1: ExpressionValue;
    value2: ExpressionValue;

    constructor() {
        super();
        this.expressionValueType = new NumberDataDefinition();

        this.value1 = ExpressionValue.createExpressionValue(this, "value1");
        this.value2 = ExpressionValue.createExpressionValue(this, "value2");
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return this.value1.evaluate(data, testContext) - this.value2.evaluate(data, testContext);
    }
}
